import { createAsyncThunk } from "@reduxjs/toolkit";

import { NewsCategory } from "../../types/NewsCategoryManager";

import { getInstrumentTypes, getNewsCategory, postNewsCategory, postRecord, putNewsCategory, updateRecord } from "./cruds";

export const ACTION_TYPE_PARENT = 'PropertyManager'

// NOTE: keep function name and thunk child name same
export const postPropertyManagerRecord = createAsyncThunk(`${ACTION_TYPE_PARENT}/postPropertyManagerRecord`,
  async (payload : any, { rejectWithValue }) => {
    try {
      const response = await postRecord(payload.propertyType, payload.description)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, data: err.response.data })
    }
  }
)

export const putPropertyManagerRecord = createAsyncThunk(`${ACTION_TYPE_PARENT}/putPropertyManagerRecord`,
  async (payload : any, { rejectWithValue }) => {
    try {
      const response = await updateRecord(payload.propertyType, payload.original, payload.description)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message, data: err.response.data })
    }
  }
)

export const fetchNewsCategory = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchNewsCategory`,
  async ({issuerId, requestHeaders} : any, { rejectWithValue }) => {
    try {
      const response = await getNewsCategory(issuerId, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

export const createNewsCategory = createAsyncThunk(`${ACTION_TYPE_PARENT}/createNewsCategory`,
  async (newsCategory : NewsCategory, { rejectWithValue }) => {
    try {
      const response = await postNewsCategory(newsCategory)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

export const updateNewsCategory = createAsyncThunk(`${ACTION_TYPE_PARENT}/updateNewsCategory`,
  async (newsCategory : NewsCategory, { rejectWithValue }) => {
    try {
      const response = await putNewsCategory(newsCategory)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

export const getInstrumentTypeCategory = createAsyncThunk(`${ACTION_TYPE_PARENT}/getInstrumentTypeCategory`,
  async (_,{ rejectWithValue }) => {
    try {
      const response = await getInstrumentTypes()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)